import React from 'react'
import { useTranslation } from 'react-i18next'
import { transformTitleToId } from 'helpers/string'

function Header() {
  const { t } = useTranslation()
  const title = t('title.local_page')

  return (
    <div id={transformTitleToId(title)} className="formatted-content">
      <h2>{title}</h2>
    </div>
  )
}

export default Header
